import Controller from '../abstracts/Controller';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
    	'NewsletterPopupComponent',
    	'ProductScrollComponent',
        'TwinWidgetCarouselComponent'
    ];
  }
}
